import { createAction } from 'redux-actions';
import { instance } from "../../../config/interceptor";

export const cleanupAction = createAction('CLEANUP_STAKEHOLDER_CHANGE_LOGO');

export const cleanup = ()  => async (dispatch) => {
  dispatch(cleanupAction());
}

export const updateLogoRequest = createAction('STAKEHOLDER_CHANGE_LOGO_REQUEST');
export const updateLogoSuccess = createAction('STAKEHOLDER_CHANGE_LOGO_SUCCESS');
export const updateLogoError = createAction('STAKEHOLDER_CHANGE_LOGO_ERROR');

export const updateLogo = (formData, stakeholderId) => async (dispatch) => {
    try {
      dispatch(updateLogoRequest());
      const resp = await instance.post(`/v1/Stakeholder/ChangeLogo/${stakeholderId}`, 
        formData, 
        { 
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      
      dispatch(updateLogoSuccess(resp.data));
  
    } catch (e) {
      if(e.response && e.response.data && e.response.data.description)
        dispatch(updateLogoError(e.response.data.description));
      else
        dispatch(updateLogoError(e.message));
    }
  };